import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import { Button, Stack, TextField, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import InputBase from "@mui/material/InputBase";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import { format, parseISO } from "date-fns";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import WelcomeNameContainer from "../../LaunchComponent/WelcomeNameContainer";
import { handleDipaLaunchLoading, handleGenerateDipaLaunch, handleGenerateDipaLaunchNewContent } from "../../Redux/Dipa";
import { fetchCampaignsData, handleCampainIDSelection, resetSubmissionButton } from "../../Redux/Mailer";
import { fetchNonCampignMails, handleFetchProgramNames } from "../../Redux/Viva";
import VivaDisplayPage from "../VivaEngane/vivaDisplayPage";
import "./LaunchDipaMailForm.css";
const WhiteBorderTextField = styled(TextField)(({
  theme
}) => ({
  " & label.Mui-focused": {
    color: " #a804ff"
  },
  " & .MuiOutlinedInput-root": {
    padding: "8.5px 12px  !important",
    "&.Mui-focused fieldset": {
      borderColor: "#a814ff",
      borderWidth: "1px"
    }
  },
  "& .MuiInputBase-input": {
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"],
    fontSize: "14px"
  },
  "& .MuiInputBase-root-MuiOutlinedInput-root": {
    padding: "1px 2px !important"
  }
}));
const CustomRadio = styled(Radio)(({
  theme
}) => ({
  "&.Mui-checked": {
    color: "#9c27b0" // Purple for the checked state
  },
  "& .MuiSvgIcon-root": {
    fontSize: "1.5rem" // Custom icon size
  },
  "&:hover": {
    backgroundColor: "rgba(156, 39, 176, 0.08)" // Optional hover effect
  }
}));
const BootstrapInput = styled(InputBase)(({
  theme
}) => ({
  "label + &": {
    marginTop: theme.spacing(3)
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 14,
    padding: "9px 26px 9px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: ["Graphik-Regular"]
  }
}));
const LaunchDipaMailForm = ({
  mailerChild,
  setMailerChild,
  setMailerParent,
  mailerParent
}) => {
  const HtmlTooltip = styled(({
    className,
    ...props
  }) => <Tooltip {...props} classes={{
    popper: className
  }} />)(({
    theme
  }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#f5f5f9",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(12),
      border: "1px solid #dadde9"
    }
  }));
  const [programNameDipaTeaser, setprogramNameDipaTeaser] = useState("");
  const [campaign, setCampaign] = useState(0);
  const [programName, setProgramName] = useState("");
  const [uniqueID, setUniqueID] = useState("");
  const campaignList = useSelector(state => state.model.campaignList);
  const options = campaignList.message !== "No campaign for this user." && campaignList.length > 0 ? campaignList.map(item => ({
    id: item.id,
    name: item.name
  })) : [];
  const [programDateDipa, setProgramDateDipa] = useState(null);
  const [isMailGeneratedDipaTeaser, setIsMailGeneratedDipaTeaser] = useState("");
  const [keyMessageDipaTeaser, setKeyMessageDipaTeaser] = useState("");
  const [mailerStatus, setMailerStatus] = useState("");
  const programDetails = useSelector(state => state.viva.programDetails);
  const programOptions = programDetails.length > 0 ? programDetails.map(item => ({
    programname: item.programname,
    uniqueID: item.uniqueID,
    category: item.category
  })) : [];
  const [isDipaTeaserMailGenerationClicked, setIsDipaTeaserGenerationClicked] = React.useState(false);
  const [isDipaTeaserNavigatedToForm, setIsDipaTeaserNavigatedToForm] = useState(false);
  const handleRadioChange = e => {
    setCategoryName(e.target.value);
    dispatch(fetchCampaignsData(e.target.value));
    handleRadioChangeReset();
    setValue(null);
  };
  const handleRadioChangeReset = () => {
    setMailerStatus("");
    setValue(null);
    setProgramName("");
    setCampaign("");
    setProgramDateDipa("");
    dispatch(resetSubmissionButton());
    setprogramNameDipaTeaser("");
    setIsDipaTeaserNavigatedToForm(false);
    setIsMailGeneratedDipaTeaser("init");
    setKeyMessageDipaTeaser();
  };
  const isMailLoaded = useSelector(state => state.dipa.isDipaLoadedLaunch);
  const mailData = useSelector(state => state.dipa.mailDataLaunch);
  const [categoryName, setCategoryName] = useState("Program");
  const dispatch = useDispatch();
  const handleDipaTeaserMailGeneration = () => {
    setIsDipaTeaserGenerationClicked(true);
    if (mailerStatus == "yes") {
      let values = {
        programNameDipaTeaser: programName,
        uniqueID: uniqueID,
        currentContent: "",
        sessionID: localStorage.getItem("sessionId")
      };
      dispatch(handleGenerateDipaLaunch(values));
    } else {
      let values = {
        programNameDipaTeaser: programNameDipaTeaser,
        uniqueID: uniqueID,
        currentContent: "",
        sessionID: localStorage.getItem("sessionId"),
        keyMessage: keyMessageDipaTeaser,
        categoryName: categoryName,
        programDateDipa: programDateDipa,
        userquery: ""
      };
      dispatch(handleGenerateDipaLaunchNewContent(values));
    }
  };
  const handleReset = () => {
    dispatch(resetSubmissionButton());
    setMailerChild("");
    setMailerParent("");
    setCategoryName("Program");
    setProgramDateDipa(null);
    setKeyMessageDipaTeaser();
    setprogramNameDipaTeaser("");
  };
  const handleCampaignID = value => {
    if (value) {
      setCampaign(value.id);
      let campaignID = value.id;
      dispatch(handleCampainIDSelection(campaignID));
      let val = "Launch";
      dispatch(handleFetchProgramNames(campaignID, val));
    }
  };
  useEffect(() => {
    dispatch(fetchCampaignsData(categoryName));
  }, []);
  const handleProgramName = value => {
    if (value) {
      setProgramName(value.programname);
      let selected = programDetails.filter(item => item.programname == value.programname);
      setUniqueID(selected[0].uniqueID);
      setIsMailGeneratedDipaTeaser("init");
    }
  };
  const [value, setValue] = React.useState(null);
  const handleChange = event => {
    if (event.target.value == "no") {
      setCampaign(0);
      dispatch(handleCampainIDSelection(0));
    }
    handleRadioChangeReset();
    setValue(event.target.value);
  };
  const handleChangeMailerStatus = event => {
    setMailerStatus(event.target.value);
    setProgramName("");
    setProgramDateDipa(null);
    setKeyMessageDipaTeaser("");
    if (event.target.value == "no" && value == "yes") {
      let data = campaignList.filter(val => val.id == campaign);
      setprogramNameDipaTeaser(data[0].name);
      const item = data[0].selectedItems.filter(val => val.title == "Learning Journey Start");
      let initialDate;
      if (item.length != 0) {
        initialDate = format(parseISO(item[0].date), "yyyy-MM-dd");
      } else {
        initialDate = "";
      }
      setProgramDateDipa(initialDate);
    }
    if (event.target.value == "yes" && value == "no") {
      dispatch(fetchNonCampignMails("Launch", categoryName));
    }
  };
  return <>
   {!isDipaTeaserMailGenerationClicked ? <Stack sx={{
      width: "100%"
    }} spacing={10}>
     <Stack sx={{
        height: "20px"
      }}>
      <WelcomeNameContainer currentComp="Dipa-Launch" />
     </Stack>
     <Stack spacing={4} sx={{
        paddingLeft: "30px",
        marginTop: "60px !important"
      }}>
      <div className="mailer-form-categories-section">
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Learning Program</span>
        <input type="radio" checked={categoryName === "Program"} value="Program" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Event</span>
        <input type="radio" checked={categoryName === "Event"} value="Event" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Microsite/Tool/Platform</span>
        <input type="radio" checked={categoryName === "Microsite/Tool/Platform"} value="Microsite/Tool/Platform" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>

       <label class="mailer-form-categories-container">
        <span className="mailer-form-categories-text">Webinar</span>
        <input type="radio" checked={categoryName === "Webinar"} value="Webinar" name="radio-category" onChange={handleRadioChange} />
        <span class="mailer-form-categories-checkmark"></span>
       </label>
      </div>
      <Stack direction={"column"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this communication part of any campaign?
          <span className="migrated-style-launchdipamailform-31fd5c-1">*</span>
         </Typography>
         <Typography>(If yes, select the campaign name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={value} onChange={handleChange} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-launchdipamailform-31fd5c-2" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-launchdipamailform-31fd5c-3" />} // Checkmark inside circle when checked
                />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-launchdipamailform-31fd5c-4" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-launchdipamailform-31fd5c-5" />} // Checkmark inside circle when checked
                />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {value == "yes" && <Stack direction={"row"} sx={{
            alignItems: "center"
          }} spacing={2}>
         <Typography>
          Select the campaign <span className="migrated-style-launchdipamailform-31fd5c-6">*</span>
         </Typography>
         <Stack sx={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginBottom: "10px",
              m: 1,
              width: "300px",
              mt: 3
            }} direction={"row"} spacing={2}>
          {/* <Select input={<BootstrapInput />} value={campaign} onChange={handleCampaignID}>
           {campaignList.message != "No campaign for this user." &&
            campaignList.length > 0 &&
            campaignList.map((item, index) => (
             <MenuItem key={index + 1} value={item.id}>
              {item.name}
             </MenuItem>
            ))}
           </Select> */}
          <Autocomplete value={options.find(option => option.id === campaign) || null} onChange={(event, newValue) => {
                handleCampaignID(newValue);
              }} options={options} getOptionLabel={option => option.name || ""} ListboxProps={{
                style: {
                  maxHeight: "150px",
                  // Fixed height for the dropdown
                  overflowY: "auto" // Enable vertical scrolling
                }
              }} renderInput={params => <TextField sx={{
                "& .MuiOutlinedInput-root": {
                  padding: "2px !important"
                }
              }} {...params} variant="outlined" />} filterSelectedOptions={false} />
         </Stack>
        </Stack>}
      </Stack>
      <Stack direction={"column"} sx={{
          alignItems: "flex-start"
        }} spacing={2}>
       <Stack direction={"row"} sx={{
            alignItems: "flex-start"
          }} spacing={2}>
        <Stack direction={"column"}>
         <Typography>
          Is this part of a Mailer?
          <span className="migrated-style-launchdipamailform-31fd5c-7">*</span>
         </Typography>
         <Typography>(If yes, select the program name)</Typography>
        </Stack>

        <FormControl>
         <RadioGroup row aria-labelledby="demo-row-radio-buttons-group-label" name="row-radio-buttons-group" value={mailerStatus} onChange={handleChangeMailerStatus} sx={{
                paddingLeft: "20px"
              }}>
          <FormControlLabel value="yes" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-launchdipamailform-31fd5c-8" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-launchdipamailform-31fd5c-9" />} // Checkmark inside circle when checked
                disabled={value == null || value == "yes" && campaign == 0 ? true : false} />} label="Yes" />
          <FormControlLabel value="no" control={<CustomRadio icon={<RadioButtonUncheckedIcon className="migrated-style-launchdipamailform-31fd5c-10" />} // Empty circle when unchecked
                checkedIcon={<CheckCircleOutlineIcon className="migrated-style-launchdipamailform-31fd5c-11" />} // Checkmark inside circle when checked
                disabled={value == null || value == "yes" && campaign == 0 ? true : false} />} label="No" />
         </RadioGroup>
        </FormControl>
       </Stack>
       {mailerStatus == "yes" && <Stack direction={"row"} spacing={2}>
         {" "}
         <Stack direction={"row"} sx={{
              alignItems: "end"
            }} spacing={2}>
          <Typography>
           Select the program name <span className="migrated-style-launchdipamailform-31fd5c-12">*</span>
          </Typography>
          <Stack sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginBottom: "10px",
                m: 1,
                width: "300px",
                mt: 3
              }} direction={"row"} spacing={2}>
           {/* <Select
            input={<BootstrapInput />}
            value={programName}
            onChange={handleProgramName}
            >
            {programDetails.length > 0 &&
             programDetails.map((item, index) => (
              <MenuItem key={index + 1} value={item.programname}>
               {item.programname}
              </MenuItem>
             ))}
            </Select> */}
           <Autocomplete value={programOptions.find(option => option.programname === programName) || null} onChange={(event, newValue) => {
                  handleProgramName(newValue);
                }} options={programOptions} getOptionLabel={option => option.programname || ""} ListboxProps={{
                  style: {
                    maxHeight: "150px",
                    // Fixed height for the dropdown
                    overflowY: "auto" // Enable vertical scrolling
                  }
                }} renderInput={params => <TextField sx={{
                  "& .MuiOutlinedInput-root": {
                    padding: "2px !important"
                  }
                }} {...params} variant="outlined" />} filterSelectedOptions={false} />
          </Stack>
         </Stack>
        </Stack>}
      </Stack>
      {mailerStatus == "no" ? <Stack direction={"column"} spacing={2} alignItems={"center"}>
        <Grid container spacing={2}>
         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Name<span className="migrated-style-launchdipamailform-31fd5c-13">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               {" "}
               {categoryName == "program" ? <p> Enter the program name </p> : categoryName == "event" ? <p> Enter the event name</p> : categoryName == "Microsite/Tool/Platform" ? <p> Enter the Microsite/Tool/Platform name</p> : <p> Enter the Webinar name</p>}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-launchdipamailform-31fd5c-14"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={categoryName == "program" ? "e.g: Java Full Stack" : categoryName == "event" ? "e.g: Google Cloud Fusion Fest" : categoryName == "webinars" ? "e.g: Azure Open AI Security" : "e.g: HMM Spark"} id="multiline" multiline InputLabelProps={{
                  shrink: false
                }} minRows={1} InputProps={{
                  readOnly: value === "yes" && campaign != 0
                }}
                //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                //  maxRows={2}
                onChange={event => {
                  setprogramNameDipaTeaser(event.target.value);
                  setIsMailGeneratedDipaTeaser("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={programNameDipaTeaser} />
          </Stack>
         </Grid>

         <Grid item xs={3}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Launch Date<span className="migrated-style-launchdipamailform-31fd5c-15">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>
               {" "}
               {categoryName == "program" ? <p> Select program launch date. </p> : categoryName == "event" ? <p> Select event launch date.</p> : categoryName == "Microsite/Tool/Platform" ? <p> Select Microsite/Tool/Platform launch date.</p> : <p> Select webinar launch date.</p>}{" "}
              </React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-launchdipamailform-31fd5c-16"></img>
            </HtmlTooltip>
           </Stack>
           <input type="date" className="maindate migrated-style-launchdipamailform-31fd5c-17" onChange={event => {
                  setProgramDateDipa(event.target.value);
                  setIsMailGeneratedDipaTeaser("init");
                }} readOnly={value == "yes" && campaign != 0 && programDateDipa != "" ? true : false}
                //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                value={programDateDipa} onKeyDown={e => e.preventDefault()} />
          </Stack>
         </Grid>
        </Grid>
        <Grid container spacing={2}>
         <Grid item xs={6}>
          <Stack spacing={0.5}>
           <Stack direction={"row"} justifyContent={"space-between"}>
            <Typography sx={{
                    fontSize: "14px",
                    fontFamily: "Graphik-Medium"
                  }}>
             Key Message<span className="migrated-style-launchdipamailform-31fd5c-18">*</span>
            </Typography>
            <HtmlTooltip arrow title={<React.Fragment>Provide key information/details.</React.Fragment>}>
             <img src={process.env.PUBLIC_URL + "/Images/info_icon.png"} className="migrated-style-launchdipamailform-31fd5c-19"></img>
            </HtmlTooltip>
           </Stack>
           <WhiteBorderTextField placeholder={"e.g: Program time/duration, venue/location, format, last date to register, etc."} id="outlined-multiline-flexible" multiline maxRows={3} minRows={3}
                //  disabled={value == null || (value == "yes" && campaign == 0) ? true : false}
                onChange={event => {
                  setKeyMessageDipaTeaser(event.target.value);
                  setIsMailGeneratedDipaTeaser("init");
                }} fullWidth sx={{
                  fontFamily: "Graphik-Regular",
                  padding: "6px,10px"
                }} value={keyMessageDipaTeaser} />
          </Stack>
         </Grid>
        </Grid>
        <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
         {isDipaTeaserNavigatedToForm && <Button sx={{
              border: "1px solid #d3d3d3",
              borderRadius: "5px",
              padding: "10px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              background: "#fff",
              color: "#a814ff",
              textTransform: "none",
              fontFamily: "Graphik-Medium"
            }} onClick={() => {
              setIsDipaTeaserGenerationClicked(true);
              setIsMailGeneratedDipaTeaser("generateOutput");
            }}>
           Next
          </Button>}
         {isMailGeneratedDipaTeaser !== "init" || programNameDipaTeaser == "" || keyMessageDipaTeaser == "" || programDateDipa == null ? <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              pointerEvents: "none",
              opacity: " 0.4"
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-launchdipamailform-31fd5c-20"></img>
           <span className="migrated-style-launchdipamailform-31fd5c-21">Generate</span>
          </Stack> : <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              cursor: "pointer"
            }} onClick={() => {
              handleDipaTeaserMailGeneration();
              setIsMailGeneratedDipaTeaser("generateOutput");
              dispatch(handleDipaLaunchLoading());
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-launchdipamailform-31fd5c-22"></img>

           <span className="migrated-style-launchdipamailform-31fd5c-23">Generate</span>
          </Stack>}
        </Stack>
       </Stack> : mailerStatus == "yes" ? <Stack spacing={4}>
        <Stack justifyContent={"center"} alignItems={"center"} direction={"row"} spacing={2}>
         {isDipaTeaserNavigatedToForm && <Button sx={{
              border: "1px solid #d3d3d3",
              borderRadius: "5px",
              padding: "10px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              background: "#fff",
              color: "#a814ff",
              textTransform: "none",
              fontFamily: "Graphik-Medium"
            }} onClick={() => {
              setIsDipaTeaserGenerationClicked(true);
              setIsMailGeneratedDipaTeaser("generateOutput");
            }}>
           Next
          </Button>}
         {isMailGeneratedDipaTeaser !== "init" || mailerStatus == null || mailerStatus == "yes" && programName == "" ? <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              pointerEvents: "none",
              opacity: " 0.4"
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-launchdipamailform-31fd5c-24"></img>
           <span className="migrated-style-launchdipamailform-31fd5c-25">Generate</span>
          </Stack> : <Stack direction={"row"} spacing={1} sx={{
              border: "2px solid #8a2be2",
              borderRadius: "28px",
              padding: " 4px 0 4px 6px",
              width: "150px",
              alignItems: "center",
              width: "150px",
              cursor: "pointer"
            }} onClick={() => {
              handleDipaTeaserMailGeneration();
              setIsMailGeneratedDipaTeaser("generateOutput");
              dispatch(handleDipaLaunchLoading());
            }}>
           <img src={process.env.PUBLIC_URL + "/Images/generate_icon.png"} className="migrated-style-launchdipamailform-31fd5c-26"></img>

           <span className="migrated-style-launchdipamailform-31fd5c-27">Generate</span>
          </Stack>}
        </Stack>
       </Stack> : null}
     </Stack>
    </Stack> : <VivaDisplayPage mailerChild={mailerChild} mailerParent={mailerParent} programName={programName} programNameViva={programNameDipaTeaser} categoryName={categoryName} handleReset={handleReset} setIsMailGeneratedVivaLaunch={setIsMailGeneratedDipaTeaser} setIsVivaLaunchGenerationClicked={setIsDipaTeaserGenerationClicked} setIsVivaNavigatedToForm={setIsDipaTeaserNavigatedToForm} mailerStatus={mailerStatus} isMailLoaded={isMailLoaded} mailData={mailData} />}
  </>;
};
export default LaunchDipaMailForm;
